import { useEffect, useRef, useState } from 'react';
import './gearSearch.scss';

const displayFor = (items, value) => {
    if (!value || value === 'manual') return 'Manual entry';
    const item = items[value];
    return item ? `${item.brand} ${item.model}` : 'Manual entry';
};

// Groups items by brand and filters by a query against "brand model", with
// "Manual entry" always pinned first regardless of the filter.
const groupedMatches = (items, query) => {
    const q = query.trim().toLowerCase();
    const entries = Object.entries(items).map(([id, it]) => ({ id, ...it }));
    const filtered = q ? entries.filter((e) => `${e.brand} ${e.model}`.toLowerCase().includes(q)) : entries;
    const groups = {};
    filtered.forEach((e) => { (groups[e.brand] = groups[e.brand] || []).push(e); });
    return Object.entries(groups).sort(([a], [b]) => a.localeCompare(b));
};

const GearSearch = ({ id, label, items, value, onChange }) => {
    const [query, setQuery] = useState(() => displayFor(items, value));
    const [open, setOpen] = useState(false);
    const [confirmed, setConfirmed] = useState(true);
    const containerRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        setQuery(displayFor(items, value));
        setConfirmed(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
                if (!confirmed) setQuery(displayFor(items, value));
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmed, value]);

    const select = (newValue) => {
        onChange(newValue);
        setQuery(displayFor(items, newValue));
        setConfirmed(true);
        setOpen(false);
    };

    const groups = open ? groupedMatches(items, confirmed ? '' : query) : [];

    return (
        <div className="gear-search" ref={containerRef}>
            <label className="fov-field-label" htmlFor={id}>{label}</label>
            <input
                id={id}
                ref={inputRef}
                type="text"
                autoComplete="off"
                value={query}
                onChange={(e) => { setQuery(e.target.value); setConfirmed(false); setOpen(true); }}
                onFocus={() => {
                    if (confirmed) { setQuery(''); setConfirmed(false); }
                    setOpen(true);
                }}
            />

            {open ? (
                <div className="gear-search-results">
                    <button
                        type="button"
                        className="gear-search-result gear-search-result--manual"
                        onClick={() => select('manual')}
                    >
                        Manual entry
                    </button>
                    {groups.length ? (
                        groups.map(([brand, brandItems]) => (
                            <div className="gear-search-group" key={brand}>
                                <p className="gear-search-group-label">{brand}</p>
                                {brandItems.map((it) => (
                                    <button
                                        type="button"
                                        key={it.id}
                                        className="gear-search-result"
                                        onClick={() => select(it.id)}
                                    >
                                        {it.model}
                                    </button>
                                ))}
                            </div>
                        ))
                    ) : (
                        <p className="gear-search-empty">No matches for &ldquo;{query}&rdquo;.</p>
                    )}
                </div>
            ) : null}
        </div>
    );
};

export default GearSearch;
